module.exports = "<div class=\"container-fluid p-0\" *ngIf=\"proposal\">\n\t<div *ngFor=\"let data of proposal.content\" class=\"text-justify\">\n\t\t<div [innerHtml]=\"data[data.name] | safe:'html'\"></div>\n\t</div>\t\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/wamp/www/sportal/pmi/web/src/app/main/proposal/proposalview/proposalview.component.html
// module id = ../../../../../src/app/main/proposal/proposalview/proposalview.component.html
// module chunks = main